import { baseUrl } from "./config/routes";
// Get useful debugging information
type BuildInfo = { branch: string; sha: string; buildTime: string };

const appBase = window.location.href;
const apiServerBase = new URL(baseUrl).origin;
let Rollbar: any;

function addBuildInfoToRollbar(rootUrl: string, section: "client" | "server") {
  return fetch(`${rootUrl}/build.json`).then(async (response) => {
    const buildInfo: BuildInfo = await response.json();

    Rollbar.configure({
      payload: {
        apiServerBase,
        appBase,
        [section]: {
          buildInfo,
        },
      },
    });
  });
}

export function start(rollbarInstance: any) {
  Rollbar = rollbarInstance;

  /*
    This is now contained in the rollbar logs using build-time env vars
    
  addBuildInfoToRollbar("", "client").catch((err) =>
    console.warn("Failed fetching client build information")
  );
   */

  addBuildInfoToRollbar(apiServerBase, "server").catch((err) =>
    console.warn("Failed fetching server build information")
  );
}
